import * as ActionTypes from "../action-types";

const dashboard_defaultState = {
  all: {
    dashboard: [],
  },
  daily: {
    summaries: [],
    employees: [],
    companies:[],
    topAppliedCompanies: [],
    topAppliedEmployees: [],
    employeesByDays: {},
    total_active_companies: 0,
    total_all_employee_activate: 0,
    total_employees: 0,
  },
  monthly: {
    summaries: [],
  },
};

export const dashboard = (state = dashboard_defaultState, action) => {
  switch (action.type) {
    case ActionTypes.DASHBOARD_GET_ALL: {
      const dashboard = action.dashboard;

      return {
        ...state,
        all: {
          dashboard,
        },
      };
    }
    case ActionTypes.DASHBOARD_TIMEFRAME_DAILY_GET_ALL: {
      const { summaries, payrolls, topAppliedCompanies, topAppliedEmployees, topAppliedEmployeesByDays, total_active_companies, total_all_employee_activate, total_employees } = action.dashboard;

      return {
        ...state,
        daily: {
          summaries,
          payrolls,
          topAppliedCompanies,
          topAppliedEmployees,
          employeesByDays: topAppliedEmployeesByDays,
          total_active_companies,
          total_all_employee_activate,
          total_employees,
        },
      };
    }
    case ActionTypes.DASHBOARD_TIMEFRAME_MONTHLY_GET_ALL: {
      const summaries = action.summaries;

      return {
        ...state,
        monthly: {
          summaries,
        },
      };
    }
    default: {
      return state;
    }
  }
};